'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { useEffect, useState } from 'react';
import i18n from '@/src/i18n';
import { sendAnalyticsData } from '@/src/utils/analytics';
import { getLanguageCode } from '@/src/utils/lang';
export const Footer = () => {
  const $ = _c(31);
  const [lang, setLang] = useState("en");
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const storedLang = typeof window !== "undefined" ? localStorage.getItem("lang") : null;
      const newLang = getLanguageCode(storedLang);
      setLang(newLang);
      i18n.changeLanguage(newLang);
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      href: "/features",
      label: i18n.t("Features")
    };
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      href: "/tutorials",
      label: i18n.t("Tutorials")
    };
    t4 = {
      href: "/blog",
      label: "Blog"
    };
    t5 = {
      href: "/hipaa",
      label: "HIPAA"
    };
    t6 = {
      href: "/ferpa",
      label: "FERPA"
    };
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
    $[6] = t6;
  } else {
    t3 = $[3];
    t4 = $[4];
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      href: "/reviews",
      label: i18n.t("Reviews")
    };
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  let t8;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      href: "/faqs",
      label: i18n.t("FAQ")
    };
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      href: "/schools-and-districts",
      label: i18n.t("Schools/Districts")
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      href: "/enterprise",
      label: i18n.t("Enterprises"),
      extraClass: "text-white"
    };
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      href: "/privacy-policy",
      label: i18n.t("Privacy Policy"),
      extraClass: "text-white"
    };
    $[11] = t11;
  } else {
    t11 = $[11];
  }
  let t12;
  if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = [t2, t3, t4, t5, t6, t7, t8, t9, t10, t11, {
      href: "/terms-of-service",
      label: i18n.t("Terms of Service"),
      extraClass: "text-white"
    }];
    $[12] = t12;
  } else {
    t12 = $[12];
  }
  const footerLinks = t12;
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="flex items-center gap-x-4 font-medium tracking-wide text-gray-100 md:justify-center lg:justify-start"><Link href="/"><span><Image src="/images/logo-blue.svg" alt="AbleSpace Logo" className="h-7 w-7" width={28} height={28} /></span></Link><span className="py-3">AbleSpace</span></div>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <div className="flex flex-col md:w-full lg:ml-14 lg:w-[85%] ">{t13}<div className="mt-5 flex h-64 flex-col flex-wrap gap-x-24 gap-y-5 text-white md:h-full md:w-full md:flex-row md:justify-center md:gap-x-8 lg:flex-row lg:justify-start xl:w-[85%]">{footerLinks.map(_temp)}</div></div>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  const t15 = `/images/customers/${lang === "es" ? "playstore_es.svg" : "playstore.svg"}`;
  let t16;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = i18n.t("App for Tracking IEP Goals, Data Collection and Student Assessment Reports");
    $[15] = t16;
  } else {
    t16 = $[15];
  }
  let t17;
  if ($[16] !== t15) {
    t17 = <Link href="https://play.google.com/store/apps/details?id=io.ablespace.androidapp" className="h-[40px] w-auto md:h-[58px] md:w-[195px]" target="_blank" rel="noopener noreferrer" onClick={_temp2}><Image src={t15} alt={`AbleSpace Android ${t16}`} width={195} height={58} className="h-full w-full object-contain" /></Link>;
    $[16] = t15;
    $[17] = t17;
  } else {
    t17 = $[17];
  }
  const t18 = `/images/customers/${lang === "es" ? "ios_es.svg" : "ios.svg"}`;
  let t19;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = i18n.t("App for Tracking IEP Goals, Data Collection and Student Assessment Reports");
    $[18] = t19;
  } else {
    t19 = $[18];
  }
  let t20;
  if ($[19] !== t18) {
    t20 = <Link href="https://apps.apple.com/us/app/ablespace-iep-goal-tracking/id1662372988" className="h-[40px] w-auto md:h-[58px] md:w-[173px]" target="_blank" rel="noopener noreferrer" onClick={_temp3}><Image src={t18} alt={`AbleSpace iOS ${t19}`} width={173} height={58} className="h-full w-full object-contain" /></Link>;
    $[19] = t18;
    $[20] = t20;
  } else {
    t20 = $[20];
  }
  let t21;
  if ($[21] !== t17 || $[22] !== t20) {
    t21 = <div className="container mx-auto p-5 md:py-10 lg:px-4"><div className="flex flex-col lg:flex-row lg:items-center lg:justify-between ">{t14}<div className="mt-5 flex items-center justify-center space-x-2 md:gap-4 md:space-x-3 ">{t17}{t20}</div></div></div>;
    $[21] = t17;
    $[22] = t20;
    $[23] = t21;
  } else {
    t21 = $[23];
  }
  let t22;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t22 = <div className="mx-auto mt-1 w-[90%] border border-[#3F598C]" />;
    $[24] = t22;
  } else {
    t22 = $[24];
  }
  let t23;
  if ($[25] === Symbol.for("react.memo_cache_sentinel")) {
    t23 = <a href="https://www.facebook.com/ablespace.io/" className="h-[28px] w-[28px]" onClick={_temp4}><Image src="/images/icons/social-media/facebook/Facebook@3x.png" width={28} height={28} alt="Facebook" /></a>;
    $[25] = t23;
  } else {
    t23 = $[25];
  }
  let t24;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t24 = <a href="https://www.instagram.com/ablespace.io/" className="h-[28px] w-[28px]" onClick={_temp5}><Image src="/images/icons/social-media/instagram/Instagram@3x.png" width={28} height={28} alt="Instagram" /></a>;
    $[26] = t24;
  } else {
    t24 = $[26];
  }
  let t25;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t25 = <div className="flex items-center justify-center gap-x-4 md:order-2 md:self-end ">{t23}{t24}<a href="https://www.youtube.com/channel/UC3g6DELgtautJeke1tHVf6g/" className="h-[28px] w-[28px]" onClick={_temp6}><Image src="/images/icons/social-media/youtube/YouTube@3x.png" width={28} height={28} alt="Youtube" /></a></div>;
    $[27] = t25;
  } else {
    t25 = $[27];
  }
  let t26;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t26 = <div className="container mx-auto mt-4 w-[84%] pb-10"><div className="flex flex-col gap-4 md:w-full md:flex-row md:justify-between md:gap-0 md:p-0 md:py-5">{t25}<div className="text-center text-sm text-gray-200 md:order-1">© 2026 Ablespace Inc. {i18n.t("All rights reserved")}.</div></div></div>;
    $[28] = t26;
  } else {
    t26 = $[28];
  }
  let t27;
  if ($[29] !== t21) {
    t27 = <div className="bg-[#283859]">{t21}{t22}{t26}</div>;
    $[29] = t21;
    $[30] = t27;
  } else {
    t27 = $[30];
  }
  return t27;
};
function _temp(t0) {
  const {
    href,
    label,
    extraClass
  } = t0;
  return <Link key={href} href={href} onClick={() => sendAnalyticsData(`FOOTER_LINK_CLICKED_${label.replace(" ", "_").toUpperCase()}`)}><span className={`text-base ${extraClass ?? ""}`.trim()}>{label}</span></Link>;
}
function _temp2() {
  return sendAnalyticsData("PLAY_STORE_BUTTON_CLICKED_FROM_FOOTER");
}
function _temp3() {
  return sendAnalyticsData("APP_STORE_BUTTON_CLICKED_FROM_FOOTER");
}
function _temp4() {
  return sendAnalyticsData("FACEBOOK_BUTTON_CLICKED_FROM_FOOTER");
}
function _temp5() {
  return sendAnalyticsData("INSTAGRAM_BUTTON_CLICKED_FROM_FOOTER");
}
function _temp6() {
  return sendAnalyticsData("YOUTUBE_BUTTON_CLICKED_FROM_FOOTER");
}